export const getMuiTheme = {
  MUIDataTableBodyCell: {
    root: {
      padding: '8px !important',
      backgroundColor: 'red',
    },
    stackedCommon: {
      '&:last-child': {
        padding: '8px !important',
      },
    },
  },
  MUIDataTableBody: {
    '.MUIDataTableBody-lastStackedCell-745 td:last-child': {
      margin: '0 -45px',
    },
  },
  overrides: {
    MUIDataTable: {
      responsiveScroll: {
        maxHeight: 'none',
      },
      responsiveStacked: {
        maxHeight: 'none',
        overflowX: 'auto',
      },
      root: {

      },
      paper: {
        borderRadius: '20px',
        position: 'relative',
      },
      responsiveBase: {
        borderBottomRightRadius: '20px',
        borderBottomLeftRadius: '20px',
      },
    },
    MUIDataTableBody: {
      stackedCommon: {
        '&:last-child': {
        },
      },
    },
    MUIDataTableBodyCell: {
      root: {
        '@media (max-width: 960px)': {
          padding: '7px !important',
        },
      },
      stackedCommon: {
        '&:nth-last-child(2)': {
          '@media (max-width: 960px)': {
            width: 'auto',
            // width: '150px',
            whiteSpace: 'nowrap',
            // marginRight: '-100px',
          },
        },
        '&:last-child': {
          whiteSpace: 'nowrap',
          '@media (max-width: 960px)': {
            width: 'auto',
            whiteSpace: 'nowrap',
            // marginRight: '100px',

          },
        },
      },
      responsiveStackedSmallParent: {
        '@media (max-width: 960px)': {
          display: 'flex',
          justifyContent: 'space-between',
        },

      },
    },
    MuiTableCell: {
      head: {
        backgroundColor: '#f3f3f3 !important',
        border: 'none',
      },
      body: {
        padding: '0 15px !important',
      },
      footer: {
        float: 'left',
        marginBottom: '20px',
        border: 'none',
      },
    },
    MUIDataTableBodyRow: {
      root: {
        padding: '0',
        '&:nth-child(even)': {
          backgroundColor: '#f5f5f5',
        },
      },
      responsiveStacked: {
        '@media (max-width: 960px)': {
          borderTop: 'none',
        },
      },
    },
    MUIDataTableToolbar: {
      filterPaper: {
        maxWidth: 'none',
        width: '30%',
      },
    },
    MUIDataTableFilter: {
      root: {
        border: '1px solid #f9b233',
        width: '100%',
        height: '100%',
        borderRadius: '5px',
      },
      header: {
        display: 'none',
      },
    },
    MuiListItem: {
      root: {
        '&.Mui-selected': {
          backgroundColor: '#f9b233',
        },
      },
      button: {
        '&:hover': {
          backgroundColor: '#fef6e7',
        },
      },
    },
    MuiInputLabel: {
      animated: {
        color: '#f9b233',
      },
    },
    MuiPopover: {
      paper: {
        maxWidth: 'none',
        width: '30%',
        border: '1px solid #f9b233',
        // paddingTop: '20px',
      },
    },
    MUIDataTableViewCol: {
      title: {
        color: '#f9b233',
        paddingTop: '20px',
      },
    },
    MuiCheckbox: {
      colorPrimary: {
        '&.Mui-checked': {
          color: '#f9b233',
        },
      },
    },
    MuiTable: {

    },
    MuiTableFooter: {
      root: {
        position: 'absolute',
        border: 'none',
        bottom: '-90px',
      },
    },
  },
}

export const getMuiThemeWithoutPadding = {
  MUIDataTableBodyCell: {
    root: {
      padding: '8px !important',
      backgroundColor: 'red',
    },
    stackedCommon: {
      '&:last-child': {
        padding: '8px !important',
      },
    },
  },
  MUIDataTableBody: {
    '.MUIDataTableBody-lastStackedCell-745 td:last-child': {
      margin: '0 -45px',
    },
  },
  overrides: {
    MuiGridListTile: {
      root: {
        '&:nth-child(3n)': {
          width: '100% !important',
        },
      },
    },
    MUIDataTable: {
      responsiveScroll: {
        maxHeight: 'none',
      },
      responsiveStacked: {
        maxHeight: 'none',
        overflowX: 'auto',
      },
      root: {

      },
      paper: {
        borderRadius: '20px',
        position: 'relative',
      },
      responsiveBase: {
        borderBottomRightRadius: '20px',
        borderBottomLeftRadius: '20px',
      },
    },
    MUIDataTableBody: {
      stackedCommon: {
        '&:last-child': {
        },
      },
    },
    MUIDataTableBodyCell: {
      root: {
        '@media (max-width: 960px)': {
          padding: '7px !important',
        },
      },
      stackedCommon: {
        '&:nth-last-child(2)': {
          '@media (max-width: 960px)': {
            // width: '150px',
            float: 'left',
            whiteSpace: 'nowrap',
          },
        },
        '&:last-child': {
          '@media (max-width: 960px)': {
            // width: '132px',
            float: 'left',
            whiteSpace: 'nowrap',
          },
        },
      },
      responsiveStackedSmallParent: {
        '@media (max-width: 960px)': {
          display: 'flex',
          justifyContent: 'space-between',
        },

      },
    },
    MuiTableCell: {
      head: {
        backgroundColor: '#f3f3f3 !important',
        border: 'none',
      },
      body: {
        padding: '10px 15px !important',
      },
      footer: {
        float: 'left',
        marginBottom: '20px',
        border: 'none',
      },
    },
    MUIDataTableBodyRow: {
      root: {
        padding: '0',
        '&:nth-child(even)': {
          backgroundColor: '#f5f5f5',
        },
      },
      responsiveStacked: {
        '@media (max-width: 960px)': {
          borderTop: 'none',
        },
      },
    },
    MUIDataTableToolbar: {
      filterPaper: {
        maxWidth: 'none',
        width: '30%',
      },
    },
    MUIDataTableFilter: {
      root: {
        border: '1px solid #f9b233',
        width: '100%',
        height: '100%',
        borderRadius: '5px',
      },
      header: {
        display: 'none',
      },
    },
    MuiListItem: {
      root: {
        '&.Mui-selected': {
          backgroundColor: '#f9b233',
        },
      },
      button: {
        '&:hover': {
          backgroundColor: '#fef6e7',
        },
      },
    },
    MuiInputLabel: {
      animated: {
        color: '#f9b233',
      },
    },
    MuiPopover: {
      paper: {
        maxWidth: 'none',
        width: '30%',
        border: '1px solid #f9b233',
        // paddingTop: '20px',
      },
    },
    MUIDataTableViewCol: {
      title: {
        color: '#f9b233',
        paddingTop: '20px',
      },
    },
    MuiCheckbox: {
      colorPrimary: {
        '&.Mui-checked': {
          color: '#f9b233',
        },
      },
    },
    MuiTable: {

    },
    MuiTableFooter: {
      root: {
        position: 'absolute',
        border: 'none',
        bottom: '-90px',
      },
    },
  },
}

// export const getMuiThemeWithoutPadding = {
// MUIDataTableBodyCell: {
// root: {
// },
// },
// overrides: {
// MUIDataTable: {
// root: {

// },
// paper: {
// borderRadius: '20px',
// position: 'relative',
// },
// responsiveBase: {
// borderBottomRightRadius: '20px',
// borderBottomLeftRadius: '20px',
// },
// },
// MuiTableCell: {
// head: {
// backgroundColor: '#f3f3f3 !important',
// border: 'none',
// },
// body: {
// // padding: '0 15px !important',
// },
// footer: {
// float: 'left',
// marginBottom: '20px',
// border: 'none',
// },
// },
// MUIDataTableBodyRow: {
// root: {
// padding: '0',
// '&:nth-child(even)': {
// backgroundColor: '#f5f5f5',
// },
// },
// },
// MUIDataTableToolbar: {
// filterPaper: {
// maxWidth: 'none',
// width: '30%',
// },
// },
// MUIDataTableFilter: {
// root: {
// border: '1px solid #f9b233',
// width: '100%',
// height: '100%',
// borderRadius: '5px',
// },
// header: {
// display: 'none',
// },
// },
// MuiListItem: {
// root: {
// '&.Mui-selected': {
// backgroundColor: '#f9b233',
// },
// },
// button: {
// '&:hover': {
// backgroundColor: '#fef6e7',
// },
// },
// },
// MuiInputLabel: {
// animated: {
// color: '#f9b233',
// },
// },
// MuiPopover: {
// paper: {
// maxWidth: 'none',
// width: '30%',
// border: '1px solid #f9b233',
// // paddingTop: '20px',
// },
// },
// MUIDataTableViewCol: {
// title: {
// color: '#f9b233',
// paddingTop: '20px',
// },
// },
// MuiCheckbox: {
// colorPrimary: {
// '&.Mui-checked': {
// color: '#f9b233',
// },
// },
// },
// MuiTable: {

// },
// MuiTableFooter: {
// root: {
// position: 'absolute',
// border: 'none',
// },
// },
// },
// }
